import { AddDeveloperComponent } from "./add-developer/add-developer.component";
import { DevelopersComponent } from "./developers/developers.component";
import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { MainSettingsComponent } from "./main-settings/main-settings.component";
import { TargetSettingsComponent } from "./target-settings/target-settings.component";
import { GeneralSettingsComponent } from "./general-settings/general-settings.component";
import { ActivityOptionsComponent } from "./activity-options/activity-options.component";
import { ChannelsOptionsComponent } from "./channels-options/channels-options.component";
import { PaymentTermsComponent } from "./payment-terms/payment-terms.component";
import { CfoPinComponent } from "./cfo-pin/cfo-pin.component";
import { TargetsGuard } from "../guards/targets.guard";
import { AddTargetComponent } from "./target-settings/add-target/add-target.component";
import { BranchesComponent } from "./branches/branches.component";
import { AddBranchComponent } from "./branches/add-branch/add-branch.component";
import { TeamsComponent } from "./teams/teams.component";
import { SettingTabGuard } from "../guards/settingsTab.guard";
import { AddTeamComponent } from "./teams/add-team/add-team.component";
import { AccountsComponent } from "./accounts/accounts.component";
import { AddAccountComponent } from "./accounts/add-account/add-account.component";
import { SetupPaymentPlansComponent } from "./setup-payment-plans/setup-payment-plans/setup-payment-plans.component";
import { ContractsComponent } from "./contracts/contracts.component";
import { AddContractComponent } from "./contracts/add-contract/add-contract.component";
import { AddTicketSettingsComponent } from "./add-ticket-settings/add-ticket-settings.component";
import { AddDepartmentTicketsComponent } from "./add-department-tickets/add-department-tickets.component";
import { DepartmentsComponent } from "./departments/departments.component";
import { ReminderOptionsComponent } from "./reminder-options/reminder-options.component";
import { OccasionsComponent } from "./occasions/occasions.component";
import { AddOccasionComponent } from "./add-occasion/add-occasion.component";
import { CustomOccasionsComponent } from "./custom-occasions/custom-occasions.component";
import { SystemVersionComponent } from "./system-version/system-version.component";
import { AddRoleComponent } from "./roles/add-role/add-role.component";
import { RolesComponent } from "./roles/roles.component";
import { EventsExpeditionComponent } from "./events-expedition/events-expedition.component";
import { AddStoreBankComponent } from "./add-store-bank/add-store-bank.component";
import { StoreBanksComponent } from "./store-banks/store-banks.component";
import { CustomerBanksComponent } from "./customer-banks/customer-banks.component";
import { AddCustomerBankComponent } from "./add-customer-bank/add-customer-bank.component";
import { PartnerComponent } from "./partner/partner.component";
import { AddPartnerComponent } from "./add-partner/add-partner.component";
import { ViewPaymentTermComponent } from "./view-payment-term/view-payment-term.component";
import { ViewNationalityComponent } from "./view-nationality/view-nationality.component";
import { AddNationalityComponent } from "./add-nationality/add-nationality.component";
import { ShareHoldersComponent } from "./share-holders/share-holders.component";
import { CampaignViewerUserGuard } from "../guards/campaign-viewer-user.guard";
import { LeadActionsComponent } from "./lead-actions/lead-actions.component";
import { MortageControlComponent } from "./mortage-control/mortage-control.component";

const routes: Routes = [
  {
    path: "",
    component: MainSettingsComponent,
    canActivate: [CampaignViewerUserGuard],
    children: [
      {
        path: "",
        redirectTo: "general",
      },
      {
        path: "general",
        component: GeneralSettingsComponent,
      },
      {
        path: "share-holders",
        component: ShareHoldersComponent,
      },
      {
        path: "activity",
        component: ActivityOptionsComponent,
      },
      {
        path: "mortage-control",
        component: MortageControlComponent,
      },
      {
        path: "events",
        component: EventsExpeditionComponent,
      },
      {
        path: "reminders-options",
        component: ReminderOptionsComponent,
      },
      {
        path: "channels",
        component: ChannelsOptionsComponent,
      },
      {
        path: "lead-actions",
        component: LeadActionsComponent,
      },
      {
        path: "payment-terms",
        component: PaymentTermsComponent,
      },
      {
        path: "view-payment-terms/:id",
        component: ViewPaymentTermComponent,
      },
      {
        path: "cfo-pin",
        component: CfoPinComponent,
      },
      {
        path: "ambassadors",
        redirectTo: "/pages/ambassadors/list",
        pathMatch: "full",
      },
      {
        path: "ambassadors/add",
        redirectTo: "/pages/ambassadors/add",
        pathMatch: "full",
      },
      {
        path: "targets",
        component: TargetSettingsComponent,
      },
      {
        path: "targets/add",
        component: AddTargetComponent,
      },
      {
        path: "branches",
        component: BranchesComponent,
      },
      {
        path: "branches/add/:id",
        component: AddBranchComponent,
      },
      {
        path: "teams",
        component: TeamsComponent,
      },
      {
        path: "teams/add/:id",
        component: AddTeamComponent,
      },
      {
        path: "accounts",
        component: AccountsComponent,
      },
      {
        path: "accounts/add/:id",
        component: AddAccountComponent,
      },
      {
        path: "setup-payment-plan",
        component: SetupPaymentPlansComponent,
      },
      {
        path: "setup-payment-plan/:id",
        component: SetupPaymentPlansComponent,
      },
      {
        path: "roles",
        component: RolesComponent,
      },
      {
        path: "roles/edit/:id",
        component: AddRoleComponent,
      },
      {
        path: "roles/clone/:id",
        component: AddRoleComponent,
      },
      {
        path: "roles/add",
        component: AddRoleComponent,
      },
      {
        path: "contracts",
        component: ContractsComponent,
      },
      {
        path: "add-contract",
        component: AddContractComponent,
      },
      {
        path: "add-ticket-settings",
        component: AddTicketSettingsComponent,
      },
      {
        path: "add-department",
        component: AddDepartmentTicketsComponent,
      },
      {
        path: "edit-department/:id",
        component: AddDepartmentTicketsComponent,
      },
      {
        path: "departments",
        component: DepartmentsComponent,
      },
      {
        path: "occasions",
        component: OccasionsComponent,
      },
      {
        path: "add-occasion",
        component: AddOccasionComponent,
      },
      {
        path: "custom-occasions",
        component: CustomOccasionsComponent,
      },
      {
        path: "system-version",
        component: SystemVersionComponent,
      },
      {
        path: "developers",
        component: DevelopersComponent,
      },
      {
        path: "developers/add",
        component: AddDeveloperComponent,
      },
      {
        path: "developers/edit/:id",
        component: AddDeveloperComponent,
      },
      {
        path: "partners",
        component: PartnerComponent,
      },
      {
        path: "partners/add",
        component: AddPartnerComponent,
      },
      {
        path: "partners/edit/:id",
        component: AddPartnerComponent,
      },
      {
        path: "nationality",
        component: ViewNationalityComponent,
      },
      {
        path: "nationality/add",
        component: AddNationalityComponent,
      },
      {
        path: "nationality/edit/:id",
        component: AddNationalityComponent,
      },
      {
        path: "store_banks",
        component: StoreBanksComponent,
      },
      {
        path: "store_banks/add",
        component: AddStoreBankComponent,
      },
      {
        path: "store_banks/edit/:id",
        component: AddStoreBankComponent,
      },
      {
        path: "customer-banks",
        component: CustomerBanksComponent,
      },
      {
        path: "customer-banks/add",
        component: AddCustomerBankComponent,
      },
      {
        path: "customer-banks/edit/:id",
        component: AddCustomerBankComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class MainSettingsRoutingModule {}



// WEBPACK FOOTER //
// ./src/app/main-settings/main-settings-routing.module.ts